import { ReactNode } from 'react'
import styled from 'styled-components'
import { useSpring, animated, useTransition } from '@react-spring/web'
import { config } from '@react-spring/web'

export const AnimatedNote = ({
  children,
  position,
  show,
  top,
  type = 'main',
  direction = 'right',
}: {
  children: ReactNode
  position: [number, number]
  show: boolean
  top?: false
  type?: string
  direction?: string
}) => {
  const svgSize = [200, 200]
  const props = useSpring({
    top: position[0],
    left: position[1],
    config: config.stiff,
  })

  const transitions = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  const handle = [100, 150]

  return (
    <>
      {transitions(
        (style, item) =>
          item && (
            <Container style={{ ...style, ...props }}>
              <Text direction={direction} type={type}>
                {children}
              </Text>
              <Svg width={svgSize[0]} height={svgSize[1]}>
                <defs>
                  <marker
                    id='head'
                    orient='auto'
                    markerWidth='50'
                    markerHeight='50'
                    refX='5'
                    refY='5'
                  >
                    <ArrowHead
                      d='M0,0 L5,5 L0,10'
                      fill='none'
                      stroke='#222426'
                    />
                  </marker>
                </defs>
                <Line
                  type={type}
                  markerEnd='url(#note-head)'
                  d={
                    direction === 'left'
                      ? `M ${150} ${100} ${100} ${100}`
                      : `M ${50} ${100} ${100} ${100}`
                  }
                  // d={`M ${50} ${150} Q ${handle[0]} ${handle[1]} ${100} ${100}`}
                />
              </Svg>
            </Container>
          )
      )}
    </>
  )
}

const Container = styled(animated.div)`
  position: absolute;
  left: 0;
  top: 0;
  width: 150px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100px;
  }
`

const Line = styled.path`
  stroke: ${({ type, theme }) =>
    type === 'main' ? theme.textColor : theme.textColor};
  stroke-width: 1px;
  fill: none;
`

const ArrowHead = styled.path`
  stroke: ${({ type, theme }) =>
    type === 'main' ? theme.textColor : theme.textColor};
  fill: none;
`

const Text = styled.div<{ type: string; direction: string }>`
  text-align: ${({ direction }) => (direction === 'right' ? 'right' : 'left')};
  transform: ${({ direction }) =>
    direction === 'right'
      ? 'translate(calc(-100% - 60px), calc(-50%))'
      : `translate(calc(100% - ${90}px), calc(-50%))`};

  ${({ theme }) => theme.breakpoints.down('md')} {
    transform: ${({ direction }) =>
      direction === 'right'
        ? 'translate(calc(-100% - 60px), calc(-50%))'
        : `translate(calc(100% - ${40}px), calc(-50%))`};
  }

  color: ${({ type, theme }) =>
    type === 'main' ? theme.textColor : theme.greyDark};
  font-size: 0.75em;
  line-height: 1.2;
  color: var(--text-color);

  text-shadow:
  1px 1px 0 ${({ theme }) => theme.textColorInverted},
  -1px 1px 0 ${({ theme }) => theme.textColorInverted},
  -1px -1px 0 ${({ theme }) => theme.textColorInverted},
  1px -1px 0 ${({ theme }) => theme.textColorInverted};

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 0.65em;
  }
`

const Svg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
`
